import React from "react";
import { Select as AntdSelect, Form } from "antd";
import { Styles } from "../Config/ThemeConfig";

export function Select({
  label,
  name,
  required,
  validation,
  options,
  onchange,
  loading,
  multiple,
  placeholder = "Search to Select",
  classname,
  allowclear = true,
  autoclearsearchvalue = true,
  defaultopen = false,
  defaultvalue,
  disabled = false,
  maxtagcount,
  size = Styles.input_size,
}) {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={[
        {
          required,
          message: validation,
        },
      ]}
      className={`w_100_p m_0 ${classname}`}
      initialValue={defaultvalue}
    >
      <AntdSelect
        allowClear={allowclear}
        autoClearSearchValue={autoclearsearchvalue}
        defaultOpen={defaultopen}
        disabled={disabled}
        maxTagCount={maxtagcount}
        className="w_100_p"
        showSearch
        mode={multiple}
        placeholder={placeholder}
        optionFilterProp="children"
        onChange={onchange}
        loading={loading}
        size={size}
        filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        options={options}
      />
    </Form.Item>
  );
}
